import * as React                      from 'react';

import { CarriageHelpEx1Vector       } from 'src/components/vector/art/carriage-help-ex1';

import { Dialog                      } from 'src/components/common/dialog';
import { IconButton                  } from 'src/components/common/icon-button';

import { Container,
         Caption,
         Message,
         Close,
         CloseOutlineVectorBig,
         CarriageHelpDialogVariants,
         carriagehelpdialog_variants } from 'src/components/features/inspection/edit/carriage-help-dialog/ui';



type Props = {
  variant: CarriageHelpDialogVariants;
  opened: boolean;
  onClose: () => void;
}
export const CarriageHelpDialog: React.FC<Props> = ({
  variant,
  opened,
  onClose,
}) => {
  const lookAndFeel = carriagehelpdialog_variants.get(variant)!;

  return (
    <Dialog variant = { lookAndFeel.dialogVariant } isOpened = { opened }>
      <Container lookAndFeel = { lookAndFeel }>
        <Close lookAndFeel = { lookAndFeel }>
          <IconButton
            variant = { lookAndFeel.closeButtonVariant }
            isTapAllowed
            onTap = { onClose }
          >
            <CloseOutlineVectorBig />
          </IconButton>
        </Close>
        <Caption lookAndFeel = { lookAndFeel }>
          Подсказка
        </Caption>
        <Message lookAndFeel = { lookAndFeel }>
          Для корректного создания осмотра необходимо ввести номер вагона и сосканировать / ввести номер сертификата качества
        </Message>
        <CarriageHelpEx1Vector />
       </Container>
    </Dialog>
  );
};
